import { logout } from '@services/oauthService'
import { Button, Result, Space } from 'antd'

interface MaintenanceScreenProps {
  title?: string
  message?: string
}

/**
 * Shown instead of the application when the signed-in user's tenant is under maintenance.
 *
 * The wording comes from what the master admin typed on the Maintenance Control screen, so it is
 * rendered as plain text — never as markup.
 */
const MaintenanceScreen = ({ title, message }: MaintenanceScreenProps) => (
  <Result
    status="warning"
    title={title || 'System maintenance'}
    subTitle={
      <div style={{ whiteSpace: 'pre-wrap', maxWidth: 640, margin: '0 auto' }}>
        {message ||
          'The system is temporarily unavailable while we apply an update. Please try again later.'}
      </div>
    }
    extra={
      <Space>
        <Button type="primary" onClick={() => window.location.reload()}>
          Try again
        </Button>
        <Button onClick={() => logout()}>Sign out</Button>
      </Space>
    }
  />
)

export default MaintenanceScreen
